




















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class Radio extends Vue {
  @Prop({ required: true }) readonly data!: Record<string, any>;
  @Prop({ required: false }) readonly parent!: Record<string, any>;
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: false }) readonly closeOpenSubCategories!: (type: string) => void;

  @Emit()
  change(value: boolean) {
    this.parent.subCat.forEach((el: Record<string, any>) => {
      el.selected = false;
    });
    this.data.selected = value;
    return { value, type: this.data.type };
  }
  openSubcategories(type: string) {
    if (this.closeOpenSubCategories) {
      this.closeOpenSubCategories(type);
    }
  }
}
